import { put, takeLatest } from "@redux-saga/core/effects";
import { ModalsAction } from "../actions";
import { MessageModalsType } from "../types";

export function* MessageModalSaga() {
    yield takeLatest(MessageModalsType.SET_MESSAGE_MODAL_DATA, showMessageModal);
    yield takeLatest(MessageModalsType.CLEAR_MESSAGE_MODAL_DATA, hideMessageModal);
}


function* showMessageModal() {
    yield put(ModalsAction.showMessageModal());
}


function* hideMessageModal() {
    yield put(ModalsAction.hideMessageModal());
}